// ✅ Action Types
import * as actionTypes from "../ActionTypes";


// ✅ Fetch Churches
export const fetchChurchesRequest = (payload, callback) => ({
  type: actionTypes.FETCH_CHURCHES_REQUEST,
  payload,
  callback,
});

export const fetchChurchesSuccess = (data) => ({
  type: actionTypes.FETCH_CHURCHES_SUCCESS,
  payload: data,
});

export const fetchChurchesFailure = (error) => ({
  type: actionTypes.FETCH_CHURCHES_FAILURE,
  payload: error,
});

// ✅ Save Church
export const saveChurchRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_CHURCH_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveChurchSuccess = (data) => ({
  type: actionTypes.SAVE_CHURCH_SUCCESS,
  payload: data,
});

export const saveChurchFailure = (error) => ({
  type: actionTypes.SAVE_CHURCH_FAILURE,
  payload: error,
});

// ✅ Delete Church
export const deleteChurchRequest = (payload, callback) => ({
  type: actionTypes.DELETE_CHURCH_REQUEST,
  payload,
  callback,
});

export const deleteChurchSuccess = (data) => ({
  type: actionTypes.DELETE_CHURCH_SUCCESS,
  payload: data,
});

export const deleteChurchFailure = (error) => ({
  type: actionTypes.DELETE_CHURCH_FAILURE,
  payload: error,
});

// ✅ Update Church
export const updateChurchRequest = (payload, callback) => ({
  type: actionTypes.UPDATE_CHURCH_REQUEST,
  payload,
  callback,
});

export const updateChurchSuccess = (data) => ({
  type: actionTypes.UPDATE_CHURCH_SUCCESS,
  payload: data,
});

export const updateChurchFailure = (error) => ({
  type: actionTypes.UPDATE_CHURCH_FAILURE,
  payload: error,
});

// ✅ Assign Church Admin
export const assignChurchAdminRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.ASSIGN_CHURCH_ADMIN_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const assignChurchAdminSuccess = (data) => ({
  type: actionTypes.ASSIGN_CHURCH_ADMIN_SUCCESS,
  payload: data,
});

export const assignChurchAdminFailure = (error) => ({
  type: actionTypes.ASSIGN_CHURCH_ADMIN_FAILURE,
  payload: error,
});

// ✅ Fetch Church by ID
export const fetchChurchByIdRequest = (_id, callback) => ({
  type: actionTypes.FETCH_CHURCH_BY_ID_REQUEST,
  payload: { _id },
  callback,
});

export const fetchChurchByIdSuccess = (church) => ({
  type: actionTypes.FETCH_CHURCH_BY_ID_SUCCESS,
  payload: church,
});

export const fetchChurchByIdFailure = (error) => ({
  type: actionTypes.FETCH_CHURCH_BY_ID_FAILURE,
  payload: error,
});
